import { render, staticRenderFns } from "./CarrierCost.vue?vue&type=template&id=b0c88ca2&scoped=true&"
import script from "./CarrierCost.vue?vue&type=script&lang=js&"
export * from "./CarrierCost.vue?vue&type=script&lang=js&"
import style0 from "./CarrierCost.vue?vue&type=style&index=0&id=b0c88ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c88ca2",
  null
  
)

export default component.exports